import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import {  NavParams, ModalController } from '@ionic/angular';

import { Communication } from '../../../models/communication/communication.model';

@Component({
  selector: 'smr-marketing-history',
  templateUrl: './marketing-history.page.html',
  styleUrls: ['./marketing-history.page.scss'],
})
export class MarketingHistoryPage implements OnInit {

  public communication: Communication;

  public decodedContent: string;

  constructor (private navParams: NavParams,
              private modalController: ModalController) {
    this.communication = this.navParams.get('communication');
    this.decodedContent = this.communication.message
      .replace(/&gt;/g, '>')
      .replace(/&lt;/g, '<')
      .replace(/&quot;/g, '"')
      .replace(/&apos;/g, "'")
      .replace(/&amp;/g, '&');
  }

  public ngOnInit () {

  }

  public onDismiss () {
    this.modalController.dismiss();
  }

}
